import w8bene from './w8bene';
import w8bene2021 from './w8bene_2021';
import w8ben from './w8ben';
import w8ben2021 from './w8ben_2021';
import w8imy from './w8imy';
import w8imy2017 from './w8imy_2017';
import w9 from './w9';
import w92017 from './w9_2017';
import w92018 from './w9_2018';
import w8eci from './w8eci';
import w8eci2021 from './w8eci_2021';
import w8exp from './w8exp';

export default {
  w8bene,
  w8bene2021,
  w8ben,
  w8ben2021,
  w8imy,
  w8imy2017,
  w9,
  w92017,
  w92018,
  w8eci,
  w8eci2021,
  w8exp
};
